export const getDisplayApr = (cakeRewardsApr?: number, lpRewardsApr?: number) => {
  if (cakeRewardsApr || lpRewardsApr) {
    return (Number(cakeRewardsApr) + Number(lpRewardsApr)).toLocaleString('en-US', { maximumFractionDigits: 2 })
  }
  if (cakeRewardsApr) {
    return cakeRewardsApr.toLocaleString('en-US', { maximumFractionDigits: 2 })
  }
  return Number(0).toLocaleString('en-US', { maximumFractionDigits: 2 })
}
